import React from 'react';
import { DataValueMap } from 'Helpers/Testing';
import { Tooltip } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import useUserContext from 'Context/UserContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  useMessagesPageCompose,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/useMessagesPageCompose';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FDTextButton } from '@facet-wealth/design';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import {
  QueryVal, removeQueryWithReplace,
} from 'Helpers/Query';

const MessagesComposeButton = () => {
  const [loading, setLoading] = React.useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const { isAgent } = useUserContext();

  const { resource } = useMetaLayoutContext();
  const householdId = resource.attr('householdId');
  const { handleCompose } = useMessagesPageCompose(householdId, 'Messages Action Bar');
  const noHouseholdSelectedForAgent = isAgent && !householdId;

  const handleClick = async () => {
    setLoading(true);
    try {
      await handleCompose();
    } catch (e) {
      displayErrorMessage(e, 'Failed to load compose draft. If this issue persists please contact support');
    } finally {
      setLoading(false);
    }
  };


  // If loadCompose is true and compose button is not disabled, autoload compose for
  useComponentDidMount(() => {
    const loadCompose = QueryVal('loadCompose');
    if (!noHouseholdSelectedForAgent && loadCompose) {
      removeQueryWithReplace('loadCompose');
      handleClick();
    }
  });

  return (
    <Tooltip title={noHouseholdSelectedForAgent ? 'You must select a household to compose a new message.' : ''} placement={'top'} arrow>
      <FDTextButton
        icon={'edit'}
        onClick={async () => handleClick()}
        disabled={noHouseholdSelectedForAgent}
        loading={loading}
        label={'Compose'}
        size={'sm'}
        {...DataValueMap.init('messages-page-compose').build()}
      />
    </Tooltip>
  );
};

MessagesComposeButton.defaultProps = {};

MessagesComposeButton.propTypes = {};

export { MessagesComposeButton };
